<template>
    <form v-on:submit.prevent>
        <div class="row">
            <div class="column">
                <h3>Project Info</h3>
                <label>Name</label><input type="text" v-model="project.name" />
                <label>Customer</label>
                <select v-model="project.customer"><option v-for="c in customers" :value="c.id" :key="c.id">#{{c.id}}: {{c.name}}</option></select>
                <label>Stage</label>
                <select v-model="project.salesstage">
                    <option v-for="opt in $store.salesstages" :key="opt.id" :value="opt.id">{{opt.name}}</option>
                </select>
                <label>Rating</label>
                <select v-model="project.rating"><option>Cold</option><option>Warm</option><option>Hot</option></select>
                <label>Number of Beds:</label>
                <input type="number" v-model="project.num_beds">
                <label>Number of Apartments:</label>
                <input type="number" v-model="project.num_apartments">
            </div>
            <div class="column">
                <h3>Address</h3>
                <label>Address 1</label><input type="text" v-model="project.address1" />
                <label>Address 2</label><input type="text" v-model="project.address2" />
                <label>Suburb</label><input type="text" v-model="project.locality" />
                <label>State</label><input type="text" v-model="project.province" />
                <label>Postcode</label><input type="text" v-model="project.postcode" />
                <label>Country</label><input type="text" v-model="project.country" />
            </div>
        </div>
        
        <h3>Notes</h3>
        <textarea v-model="project.notes"></textarea>

        <button @click="saveProject">Save</button>
    </form>
</template>

<script>
    import {CallApi} from '../Utilities.js'

    export default {
        name: 'ProjectCreate',
        data: function() {
            return {
                customers: [],
                project: {
                    name: '',
                    customer: 0,
                    salesstage: 0,
                    rating: 'Warm',
                    address1: '',
                    address2: '',
                    locality: '',
                    province: '',
                    postcode: '',
                    country: '',
                    notes : '',
                    num_beds: 0,
                    num_apartments: 0,
                }
            }
        },
        methods: {
            saveProject: async function() {
                const apiResult = await CallApi('POST', '/projects', this.project)
                if (apiResult.project) {
                    this.$router.push(`/projects/${apiResult.project.id}`)
                }
            }
        },
        mounted: async function () {
            this.customers = ((await CallApi('GET', '/my-account/customers')).customers) || []
        }
    }
</script>